import React, { Dispatch, ReactNode, SetStateAction } from 'react';
import { intersection, not } from './helpers/filterObjects';
import { TransferList } from './TransferList';
import {
    createHandleAdd,
    createHandleRemove,
} from './helpers/transferHandlers';

export const ITEMS_TOGGLE_LIMIT = 10000;

export interface IFilterInitialState {
    typeUnassigned: string;
    nameUnassigned: string;
    typeAssigned: string;
    nameAssigned: string;
}

export interface IListObjectInitialState<T> {
    unassignedObjects: T[];
    assignedObjects: T[];
    filteredAssignedObjects: T[];
    originalAssignedObjects: T[];
}

export interface ITransferListObject {
    relationId: string;
    type: string;
    name: string;
}

interface IOwnProps<T> {
    objectLists: IListObjectInitialState<T>;
    setObjectLists: React.Dispatch<Partial<IListObjectInitialState<T>>>;
    added: T[];
    setAdded: Dispatch<SetStateAction<T[]>>;
    removed: T[];
    setRemoved: Dispatch<SetStateAction<T[]>>;
    filter: IFilterInitialState;
    checked: T[];
    setChecked: Dispatch<SetStateAction<T[]>>;
    filterObjects: (items: T[], type: string, name: string) => T[];
    customComponents: { leftList: ReactNode; rightList: ReactNode };
}

export default function CommonTransferList<T extends ITransferListObject>(
    props: IOwnProps<T>
) {
    const { filter, customComponents, objectLists, checked } = props;
    const { typeAssigned, nameAssigned, typeUnassigned, nameUnassigned } =
        filter;

    const utils = { intersection, not };
    const handleAdd = createHandleAdd<T>({
        props,
        type: typeAssigned,
        name: nameAssigned,
        utils,
    });
    const handleRemove = createHandleRemove<T>({
        props,
        type: typeUnassigned,
        name: nameUnassigned,
        utils,
    });

    return (
        <TransferList<T>
            objectLists={objectLists}
            checked={checked}
            customComponents={customComponents}
            intersection={intersection}
            handleAdd={handleAdd}
            handleRemove={handleRemove}
        />
    );
}
